import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Spacer,
  useBreakpointValue,
  VStack,
} from '@chakra-ui/react';
import { MODAL_FOOTER_PB, MOBILE_FULL_SCREEN_MODAL_CONTENT_PROPS } from '@/constants/mobileLayout';
import { useTeamDetail } from './TeamDetailContext';
import { TeamDetailHero } from './TeamDetailHero';
import { TeamDetailFixtures } from './TeamDetailFixtures';
import { TeamDetailGroup } from './TeamDetailGroup';

export function TeamDetailModal() {
  const { state, closeTeamDetail, fixtures, gameResults } = useTeamDetail();
  const isMobile = useBreakpointValue({ base: true, md: false }) ?? true;
  const modalMaxW = useBreakpointValue({ base: '100%', md: '520px', lg: '640px' });
  const country = state?.country;

  return (
    <Modal
      isOpen={state != null}
      onClose={closeTeamDetail}
      scrollBehavior='inside'
      size={isMobile ? 'full' : 'xl'}
    >
      <ModalOverlay />
      <ModalContent
        {...(isMobile ? MOBILE_FULL_SCREEN_MODAL_CONTENT_PROPS : { maxW: modalMaxW, borderRadius: '12px', mx: 2 })}
      >
        <ModalCloseButton mt={2} mr={2} />
        <ModalBody
          px={{ base: 4, md: 6 }}
          py={6}
          pb={MODAL_FOOTER_PB}
          flex={isMobile ? 1 : undefined}
          minH={isMobile ? 0 : undefined}
          overflowY={isMobile ? 'auto' : undefined}
        >
          {country ? (
            <VStack align='stretch' spacing={4}>
              <TeamDetailHero country={country} />
              <TeamDetailFixtures country={country} fixtures={fixtures} gameResults={gameResults} />
              <TeamDetailGroup country={country} />
              <Spacer h={1} />
            </VStack>
          ) : null}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
